/* Homepage behavior: scroll-scrubbed video, scroll reveal, scroll indicator, quick add-to-cart. */
(function () {
  /* Scroll video */
  var sec = document.getElementById('cl-sv-section');
  var vid = document.getElementById('cl-sv-vid');
  var phases = [0, 1, 2, 3].map(function (i) { return document.getElementById('cl-sv-p' + i); });
  if (sec) {
    var duration = 0, lastPhase = -1;
    var showPhase = function (i) {
      if (i === lastPhase) return; lastPhase = i;
      phases.forEach(function (el, j) {
        if (!el) return;
        var on = j === i;
        el.style.opacity = on ? '1' : '0';
        el.style.transform = on ? 'translateY(0)' : 'translateY(28px)';
      });
    };
    var scrub = function () {
      var top = sec.getBoundingClientRect().top;
      var total = sec.offsetHeight - window.innerHeight;
      var pct = Math.min(1, Math.max(0, -top / total));
      if (vid && duration > 0) { try { vid.currentTime = pct * duration; } catch (e) {} }
      showPhase(Math.min(3, Math.floor(pct * 4)));
    };
    if (vid) {
      vid.pause();
      var onMeta = function () { duration = vid.duration || 0; vid.pause(); scrub(); };
      if (vid.readyState >= 1 && vid.duration) { onMeta(); }
      else {
        vid.addEventListener('loadedmetadata', onMeta);
        vid.addEventListener('canplay', function () { if (!duration && vid.duration) onMeta(); });
      }
      vid.load();
    }
    showPhase(0);
    window.addEventListener('scroll', scrub, { passive: true });
    scrub();
  }

  /* Scroll reveal */
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('vis'); obs.unobserve(e.target); } });
  }, { threshold: .1, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('[data-reveal]').forEach(function (el) { obs.observe(el); });

  /* Scroll indicator */
  var scrollLine = document.getElementById('scroll-line');
  var scrollInd = document.getElementById('scroll-indicator');
  if (scrollLine) {
    var st = null;
    (function al(ts) {
      if (!st) st = ts;
      if (window.scrollY < 20) {
        var t = ((ts - st) % 1600) / 1600;
        scrollLine.style.transform = 'translateY(' + (t * 100) + '%)';
        scrollLine.style.opacity = t < .7 ? '.65' : String(.65 * (1 - (t - .7) / .3));
      }
      if (scrollInd) scrollInd.style.opacity = String(Math.max(0, 1 - window.scrollY / 200));
      requestAnimationFrame(al);
    })(0);
  }

  /* Quick add-to-cart (one listener per form) */
  document.querySelectorAll('.cl-atc-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var id = form.querySelector('input[name="id"]').value;
      if (btn) btn.textContent = 'Adding\u2026';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 }) })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (btn) { btn.textContent = 'Added!'; setTimeout(function () { btn.textContent = 'Add to Cart'; }, 2000); }
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
          });
        })
        .catch(function () { if (btn) { btn.textContent = 'Add to Cart'; } window.location = '/cart'; });
    });
  });
})();